import React from 'react'
import ExternalModal from 'designer/external/ExternalModal'

const ModalWrapper = (props) => {
  const { children } = props

  return (
    <React.Fragment>
      {children}
      <ExternalModal {...props} />
    </React.Fragment>
  )
}

ModalWrapper.defaultProps = {
  modalSize: '',
  modalHeaderColor: '',
  textHeaderColor: '',
  code: { form: '', page: '' },
  modalCode: '',
  data: {},
  designerData: {},
  callback: {},
  onCloseModal: () => {},
  onUpdateData: () => {},
  onSelectRow: () => {},
}

export default ModalWrapper
